import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromComponentToName from 'utils/react/fromComponentToName.util';
import replaceNaN from 'utils/values/replaceNaN.util';

const withSalonId = (Component) => {
  // find out the name of the wrapped component or use a default one
  const displayName = `withSalonId(${fromComponentToName(Component)})`;

  // create the wrapper component and use it to render the wrapped one
  const WithSalonId = (props) => {
    const currentSalonIdFromRedux = useSelector(selectCurrentSalonId);
    const { id: idFromParams, salonId: salonIdFromParams } = useParams();

    // NOTE: salonId takes precedence since id can be used for other things, especially when salonId is present
    const currentSalonIdFromParams = replaceNaN(0, fromAnyToInteger(fromAnyToTrimmed(salonIdFromParams) || fromAnyToTrimmed(idFromParams)));

    const salonId = currentSalonIdFromRedux || currentSalonIdFromParams;

    // NOTE: extra props in case one wants to use specifically the Redux or the params version
    const extra = { salonId, currentSalonIdFromRedux, currentSalonIdFromParams };

    return <Component {...props} {...extra} />;
  };

  // static fields must be copied from the wrapped to the wrapper
  hoistNonReactStatics(WithSalonId, Component);

  // nice display name for the wrapper
  WithSalonId.displayName = displayName;

  return WithSalonId;
};

export default withSalonId;
